/** face comparison */
export const FETCH_POST_FACE_COMPARISON= 'FETCH_POST_FACE_COMPARISON';
export const FETCH_POST_FACE_COMPARISON_SUCCESS= 'FETCH_POST_FACE_COMPARISON_SUCCESS';
export const FETCH_POST_FACE_COMPARISON_FAILED= 'FETCH_POST_FACE_COMPARISON_FAILED';